import { httpClient } from '@/shared/api';
import type { PickListItemDto, PickListItemGroupDto } from './pickList.dto';

const PREFIX = '/app/pick-list';

function readStr(o: Record<string, unknown>, keys: string[]): string | undefined {
  for (const k of keys) {
    const v = o[k];
    if (typeof v === 'string' && v.trim() !== '') return v;
    if (typeof v === 'number' && Number.isFinite(v)) return String(v);
  }
  return undefined;
}

function readBool(o: Record<string, unknown>, keys: string[]): boolean {
  for (const k of keys) {
    const v = o[k];
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') {
      const t = v.trim().toLowerCase();
      if (t === 'true') return true;
      if (t === 'false') return false;
    }
  }
  return false;
}

function parseGroup(raw: unknown): PickListItemGroupDto | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const name = readStr(o, ['name', 'Name']);
  if (!name) return null;
  return { name, disabled: readBool(o, ['disabled', 'Disabled']) };
}

function parseItem(raw: unknown): PickListItemDto | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const value = readStr(o, ['value', 'Value', 'id', 'Id']);
  const text = readStr(o, ['text', 'Text', 'label', 'Label', 'name', 'Name']);
  if (!value || !text) return null;
  return {
    value,
    text,
    disabled: readBool(o, ['disabled', 'Disabled']),
    selected: readBool(o, ['selected', 'Selected']),
    group: parseGroup(o['group'] ?? o['Group']),
  };
}

function parseList(raw: unknown): PickListItemDto[] {
  if (Array.isArray(raw)) {
    return raw.map(parseItem).filter((x): x is PickListItemDto => x != null);
  }
  if (raw && typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    for (const k of ['items', 'Items', 'result', 'Result', 'data', 'Data']) {
      const v = o[k];
      if (Array.isArray(v)) return v.map(parseItem).filter((x): x is PickListItemDto => x != null);
    }
  }
  return [];
}

export const pickListApi = {
  /** GET /api/app/pick-list/pick-list-by-code-select-item?Code=… */
  getByCode: async (code: string): Promise<PickListItemDto[]> => {
    const q = new URLSearchParams();
    q.set('Code', code);
    const raw = await httpClient.get<unknown>(`${PREFIX}/pick-list-by-code-select-item?${q.toString()}`);
    return parseList(raw);
  },
};
